import React, { useState } from "react";

import Table from "@Components/Table";
import Filter from "@Components/Filter";
import {
  BO_LIST_SHOP_URL,
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  ZONE_FETCH_URL,
} from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";

let model = [
  { id: "name", label: "Shop Name", type: "string" },
  { id: "company_name", label: "Company", type: "string" },
  { id: "zone_name", label: "Zone", type: "string" },
  { id: "region_name", label: "Region", type: "string" },
  { id: "estate_name", label: "Estate", type: "string" },
  {
    id: "active",
    label: "Status",
    type: "boolean",
    yesValue: "Active",
    noValue: "Inactive",
  },
];
const pageNumberDropdown = true;

const filterInitialValues = {
  shop_name: "",
  company: "",
  zone: "",
  region: "",
  estate: "",
};
const isShopDelete = true;


const ShopList = () => {
  const [filterValues, setFilterValues] = useState({});
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableZone, setDisableZone] = useState(true);

  const actions = ["edit", "delete"];

  const filterFields = [
    {
      type: "input",
      label: "Shop Name",
      name: "shop_name",
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: false,
      gridSize: {
        lg: 4,
      },
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: false,

      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
      gridSize: {
        lg: 4,
      },
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,

      paginated: false,
      disabled:disableEstate,
      gridSize: {
        lg: 4,
      },
      optionsDependsOn: "region",
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
    },
  ];

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };
const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };
  return (
    <>
      <div>
        <Filter
          initialValues={filterInitialValues}
          filterFields={filterFields}
          onSubmit={onFilterRequest}
        />
        <Table
          proxyURL={BO_LIST_SHOP_URL}
          actions={actions}
          model={model}
          filterValues={filterValues}
          isShopDelete = {isShopDelete}
          noFilter
          pageNumberDropdown={pageNumberDropdown}

        />
      </div>
    </>
  );
};

export default ShopList;
